export var BUTTON_CLASSES = {
    BASE: 'tw-items-center tw-justify-center tw-inline-flex tw-overflow-hidden tw-relative tw-font-normal tw-select-none tw-text-center tw-align-bottom tw-w-full tw-h-full tw-transition tw-duration-200 tw-ease-in-out focus:tw-outline-none focus:tw-ring-0 focus:tw-ring-offset-0 focus-visible:tw-outline-2 focus-visible:tw-ring-2 focus-visible:tw-ring-offset-2 focus-visible:tw-ring-primary-700 tw-border tw-rounded-md',
    SEVERITY: {
        PRIMARY: 'tw-text-white tw-bg-primary-500 hover:tw-bg-primary-600 group-hover:tw-bg-primary-600 tw-border-transparent',
        SECONDARY: 'tw-text-gray-900 dark:tw-text-gray-100 tw-bg-white tw-border-gray-300 hover:tw-bg-gray-200 hover:tw-border-gray-200 dark:tw-bg-zinc-700 dark:tw-border-zinc-500 dark:hover:tw-bg-zinc-600',
        DANGER: 'tw-text-white tw-bg-red-500 tw-border-red-500 hover:tw-bg-red-600 hover:tw-border-red-600',
        SUCCESS: 'tw-text-white tw-bg-green-600 tw-border-green-600 hover:tw-bg-green-700 hover:tw-border-green-700',
    },
    OUTLINE: {
        PRIMARY: 'tw-border-primary-500 hover:tw-border-primary-500 hover:tw-bg-primary-500 tw-text-primary-500 hover:tw-text-white dark:tw-text-primary-400 dark:hover:tw-text-white',
        SECONDARY: 'tw-text-gray-900 dark:tw-text-gray-100 tw-border-gray-300 hover:tw-bg-gray-200 hover:tw-border-gray-200 dark:tw-border-zinc-500 dark:hover:tw-bg-zinc-600',
        DANGER: 'tw-text-red-600 tw-border-red-500 dark:tw-text-red-300 dark:tw-border-red-500 dark:hover:tw-text-red-100 hover:tw-bg-red-900/10',
        SUCCESS: 'tw-text-green-600 tw-border-green-500 dark:tw-text-green-300 dark:tw-border-green-500 dark:hover:tw-text-green-100 hover:tw-bg-green-900/10',
    },
    TABLE_ACTION: {
        BASE: [
            'tw-p-1 tw-rounded',
            'tw-text-primary-600',
            'hover:tw-text-primary-600 hover:tw-backdrop-opacity-10 hover:tw-backdrop-brightness-[.25] dark:hover:tw-backdrop-opacity-50 dark:hover:tw-text-gray-200',
            'focus:tw-outline-none focus:tw-ring-0 focus:tw-ring-offset-0 focus-visible:tw-outline-2 focus-visible:tw-ring-2 focus-visible:tw-ring-offset-2 focus-visible:tw-ring-primary-700',
        ],
        DISABLED: ['!tw-text-gray-800 tw-pointer-events-none tw-opacity-60'],
    },
};
export function getButtonClasses(props) {
    var _a, _b;
    var classes = [BUTTON_CLASSES.BASE];
    if (props.text) {
        classes.push('tw-bg-transparent tw-border-transparent tw-border-0');
        if (props.severity === 'secondary' && !props.link) {
            classes.push('tw-text-gray-600 dark:tw-text-gray-300 hover:tw-bg-gray-200 dark:tw-hover:bg-zinc-600');
        }
        else if (props.severity === 'danger' && !props.link) {
            classes.push('tw-text-red-500 dark:tw-text-red-400 hover:tw-bg-red-300/20');
        }
        else if (props.severity === 'success' && !props.link) {
            classes.push('tw-text-green-500 dark:tw-text-green-400 hover:tw-bg-green-300/20');
        }
    }
    else if (props.outlined) {
        classes.push('tw-bg-transparent');
        var severityKey = (_a = props.severity) === null || _a === void 0 ? void 0 : _a.toUpperCase();
        if (severityKey && BUTTON_CLASSES.OUTLINE[severityKey]) {
            classes.push(BUTTON_CLASSES.OUTLINE[severityKey]);
        }
    }
    else if (props.link) {
        classes.push('tw-bg-transparent tw-border-transparent tw-font-semibold');
        if (props.severity === 'primary') {
            classes.push('tw-text-primary-600 hover:tw-text-primary-700 dark:tw-text-primary-200 dark:hover:tw-text-primary-300');
        }
        else if (props.severity === 'secondary') {
            classes.push('tw-text-gray-700 dark:tw-text-gray-100 hover:tw-text-gray-800 dark:hover:tw-text-white');
        }
    }
    else {
        var severityKey = (_b = props.severity) === null || _b === void 0 ? void 0 : _b.toUpperCase();
        if (severityKey && BUTTON_CLASSES.SEVERITY[severityKey]) {
            classes.push(BUTTON_CLASSES.SEVERITY[severityKey]);
        }
    }
    return classes;
}
